import React from 'react';
import { CommonPageStep, ResetPasswordPageStep } from '..';
import * as qs from 'query-string';
import { isMobileOnly } from 'react-device-detect';
import { Navigate } from 'react-router-dom';
import { DesktopView } from './desktop/ResetPassword.desktop';
import { MobileView } from './mobile/ResetPassword.mobile';
import apiHelper, {
  SupportedIncomingFormat,
  SupportedMethod,
  SupportedOutgoingFormat,
  SupportedServers,
} from '../../common/ApiHelper';
import { appConfig } from '../../common/ConfigLoader';
import { useAppSelector } from '../../store/hooks';
import {
  selectAppPageStep,
  setAppPageStep,
} from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';
import { Login } from '../login';

export const ResetPassword = (): JSX.Element => {
  // Redux Hooks
  const appPageStep = useAppSelector(selectAppPageStep);

  // LOCAL HOOKS
  const [validSessionToken, setValidSessionToken] = React.useState(true);

  // ELEMENT FUNCTIONS
  const checkResetSessionToken = async () => {
    // Get reset credentials from links
    const parmsValue = qs.parse(window.location.search);

    // Verify the session token
    const emailSessionTokenValidationEndpoint =
      'verification/EmailSessionTokenVerification';
    const verifyResult = await apiHelper(
      SupportedServers.ACCOUNT,
      emailSessionTokenValidationEndpoint,
      SupportedMethod.POST,
      parmsValue,
      {
        incomingFormat: SupportedIncomingFormat.JSON,
        outgoingFormat: SupportedOutgoingFormat.JSON,
      },
    );

    // Set reset credential for this reset password page
    console.log(verifyResult);
    if (verifyResult.data) {
      return { success: true, data: verifyResult };
    }

    // DEV
    setValidSessionToken(false);

    return { success: false, data: verifyResult };
  };

  React.useEffect(() => {
    outsideComponentDispatch(setAppPageStep(ResetPasswordPageStep.RESET));
    void checkResetSessionToken();
  }, []);

  return (
    <React.Fragment>
      {isMobileOnly ? <MobileView /> : <DesktopView />}
      {appPageStep === CommonPageStep.LOGIN ? <Navigate to="/Login" /> : null}
      {validSessionToken ? null : <Navigate to="/404" />}
    </React.Fragment>
  );
};
